var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.dc285f9ce448cefab31a537ef4ecffd5.svg#Y';
                    var viewUrl = 'sprites.dc285f9ce448cefab31a537ef4ecffd5.svg#view-Y';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 22 19',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };